import React, { forwardRef } from 'react';

import * as S from './Link.styles';

export const Link = forwardRef((props, ref) => <S.Link {...props} ref={ref} />);

Link.displayName = 'Link';
